import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Award, Users } from 'lucide-react';
const values = [{
  title: 'Innovation',
  description: "We push boundaries to create exceptional user experiences. We don't just follow trends; we set them by questioning the status quo.",
  icon: Lightbulb
}, {
  title: 'Quality First',
  description: 'Every app is built with meticulous attention to detail. From the first line of code to the final pixel, we ensure excellence.',
  icon: Award
}, {
  title: 'User-Centric',
  description: 'Our products solve real problems for real people. We listen, adapt, and evolve based on genuine user feedback and needs.',
  icon: Users
}];
export function ValuesSection() {
  return <section className="py-24 bg-white" data-id="element-85">
      <div className="container mx-auto px-4 md:px-6" data-id="element-86">
        <div className="grid md:grid-cols-3 gap-12" data-id="element-87">
          {values.map((value, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="flex flex-col items-center text-center" data-id="element-88">
              <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-6 text-slate-900 border border-slate-100" data-id="element-89">
                <value.icon className="w-8 h-8" strokeWidth={1.5} data-id="element-90" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-91">
                {value.title}
              </h3>
              <p className="text-slate-600 leading-relaxed max-w-sm" data-id="element-92">
                {value.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}